import React from "react";
import DashboardTitle from "../DashboardTitle/DashboardTitle";
import Airplane from "../../../Shared/Svgs/Airplane";
import ActiveProject from "./ActiveProject/ActiveProject";
import useStore from "../../../../../js/state/state";

const ActiveProjects = () => {
    const { projects } = useStore();

    return (
        <div className="ActiveProjects">
            <DashboardTitle
                title="Active Projects"
                svg={<Airplane />}
            />
            <div className="activeProjectsContainer">
                {projects
                    .slice(0, 6)
                    .map((project, index) => (
                        <ActiveProject
                            key={index}
                            title={project.title}
                            status={project.status}
                            completion={project.completion}
                            isPositive={project.isPositive}
                        />
                    ))}
            </div>
        </div>
    );
};

export default ActiveProjects;
